export default __webpack_public_path__ + "static/media/cv.a77cb249.svg";